const getScreenInfo = () => {
  if (typeof window === 'undefined') {
    return { minDimension: 0, width: 0, height: 0 };
  }

  const width = window.innerWidth ?? 0;
  const height = window.innerHeight ?? 0;
  const minDimension = Math.min(width, height);

  return { minDimension, width, height };
};

const isSmallViewport = () => {
  const { minDimension, width, height } = getScreenInfo();
  const threshold = width > height ? 600 : 768;
  return minDimension < threshold;
};

export const isPhoneDevice = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return isSmallViewport();
};
